<template>
    <div class="column is-half is-offset-one-quarter">
        <transition name="fade">
            <div class="notification" 
                v-bind:class="{ 'is-danger': notification.isError, 'is-success': !notification.isError }" 
                v-if="this.notification.msg !== ''">
            {{notification.msg}}
            </div>
        </transition>
        <div class="box">
            <div class="field">
                    <div class="control">
                        <label class="label">Aktuelle Mailadresse</label>
                        <input class="input" type="email" disabled v-model="user.mail">
                    </div>
                </div>
            <form v-on:submit.prevent>
                <div class="field">
                    <div class="control">
                        <label class="label">Neue Mailadresse</label>
                        <input class="input" type="email" required v-model="input.mail">
                    </div>
                </div>
                <div class="field">
                    <div class="control">
                        <label class="label">Wiederholen</label>
                        <input class="input" type="email" required v-model="input.repeat">
                    </div>
                </div>
                <button class="button is-primary is-pulled-right" @click="submit()">Speichern</button>
            </form>
        </div>
    
    </div>
</template>

<script>
import {API} from '@/assets/ts/api'
export default {
    data() {
        return {
            notification: {
                msg: '',
                isError: false,
            },
            input: {
                mail: '',
                repeat: '',
            },
            user: {},
        }
    },
    mounted: function() {
        API.getMe().then((response) => {
            this.user = response.data;
        })
    },
    methods: {
        submit() {
            if (this.input.mail === this.input.repeat) {
                API.changeMail(this.input.mail).then(() => {
                    this.notification.msg = 'Bestätigungsmail gesendet';
                    this.notification.isError = false;
                }).catch((error) => {
                    const data = error.response.data;
                })
            } else {
                this.notification.msg = 'Mailadressen stimmen nicht überein';
                this.notification.isError = true;
            }
            
        },
    }
}
</script>

<style>
.fade-enter-active, .fade-leave-active {
  transition: opacity .75s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
